export const GLOBAL_TABLET_MENU_LINKS = [
  {
    links: [
      { name: 'ランキング', url: '/K007/index.html' },
      { name: '導入後推移', url: '/K012/index.html' },
      { name: '設定別', url: '/K013/index.html' },
    ],
  }
];

export default GLOBAL_TABLET_MENU_LINKS;
